module.exports = __webpack_public_path__ + "img/1566919019.2a48f693.jpg";